import clsx from 'clsx';

interface SkeletonBlockProps extends React.ComponentPropsWithoutRef<'div'> {
  className?: string;
}

export function SkeletonBlock({ className, ...otherProps }: SkeletonBlockProps) {
  return (
    <div
      className={clsx(
        'bg-gray-200',
        !(typeof className !== 'undefined' && className.indexOf('rounded') > -1) && 'rounded-md',
        className
      )}
      {...otherProps}
    />
  );
}
